import React, { FC, useEffect } from 'react';
import { Field } from '@alifd/next';
import Requests from '@/services/request';
import $i18n from '../../../../../../i18n';
import { getQueryStringArgs } from '@/utils/url-parse';
import { Modal, Form, Input, Message } from '@b-design/fusion';
import {promisifyValidate} from '@/components/Button';
import './index.less';

/**
 * 编辑工作流别名弹框
 */
interface PropsType {
  visible: boolean;
  setVisible: (value: boolean) => void;
  record: any;
  updateData: () => void;
}

const EditAliasNameModal: FC<PropsType> = ({ visible, setVisible, record, updateData }) => {
  const field = Field.useField();
  const { spaceId } = getQueryStringArgs();
  const { getError, setValues, reset, init } = field;

  const onSave = async () => {
    const [errs, values] = await promisifyValidate(field);
      if (errs) {
        return;
      }
      const data = await Requests.post('/rest/intercnn/aigc/workflow/modify/alias', {
        spaceId,
        identify: values.identify,
        alias: values.alias,
      });
      if (data) {
          Message.success(
            $i18n.get({
              id: 'aopf.pages.miniapp.drawer.form.Update.successfully',
              dm: '更新成功',
            }),
          );
          setVisible(false);
          updateData();
        }
  };

  useEffect(() => {
    if (!visible) return;
    reset();
    setValues(record || {});
  }, [visible, record]);

  return (
    <Modal
      visible={visible}
      title={$i18n.get({ id: 'aopf.component.editAliasNameModal.WorkflowAlias', dm: '工作流别名' })}
      onCancel={() => setVisible(false)}
      onClose={() => setVisible(false)}
      onOk={onSave}
      className="edit-alias-name-modal"
      footerActions={['cancel', 'ok']}
    >
      <Form>
        <Form.Item
          name="identify"
          label={$i18n.get({ id: 'aopf.component.editAliasNameModal.WorkflowId', dm: '工作流ID' })}
        >
          <Input
            disabled
            {...init('identify', {
              initValue: '',
            })}
          />
        </Form.Item>
        <Form.Item
          name="name"
          label={$i18n.get({
            id: 'aopf.component.editAliasNameModal.WorkflowName',
            dm: '工作流名称',
          })}
        >
          <Input
            disabled
            {...init('name', {
              initValue: '',
            })}
          />
        </Form.Item>
        <Form.Item
          name="alias"
          label={$i18n.get({
            id: 'aopf.component.editAliasNameModal.WorkflowAlias',
            dm: '工作流别名',
          })}
          required
        >
          <Input
            placeholder={$i18n.get({
              id: 'aopf.component.editAliasNameModal.PleaseEnter',
              dm: '请输入',
            })}
            {...init('alias', {
              initValue: '',
              rules: {
                required: true,
                maxLength: 120,
                message: $i18n.get({
                  id: 'aopf.component.editAliasNameModal.EnterAWorkflowAlias',
                  dm: '请输入不超过120个字符的工作流别名',
                }),
              },
            })}
          />

          <p style={{ fontSize: 12, color: '#c82727', height: '32px' }}>
            {getError('alias') || ''}
          </p>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditAliasNameModal;
